import { render, staticRenderFns } from "./LegislativeProposals.vue?vue&type=template&id=618cbe52"
import script from "./LegislativeProposals.vue?vue&type=script&lang=js"
export * from "./LegislativeProposals.vue?vue&type=script&lang=js"
import style0 from "./LegislativeProposals.vue?vue&type=style&index=0&id=618cbe52&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports